"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHifiStorefrontCardCTAClick = void 0;
/**
 * A builder for HifiStorefrontCardCTAClick
 *
 * @param data - The event data
 * @return The formatted event data for HifiStorefrontCardCTAClickEvent
 */
function createHifiStorefrontCardCTAClick(data) {
    return {
        name: 'HifiStorefrontCardCTAClick',
        environments: ['browser'],
        data: data,
    };
}
exports.createHifiStorefrontCardCTAClick = createHifiStorefrontCardCTAClick;
//# sourceMappingURL=createHifiStorefrontCardCTAClick.js.map